"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Functions;
(function (Functions) {
  Functions["Min"] = "min";
  Functions["Max"] = "max";
})(Functions || (Functions = {}));
var _default = Functions;
exports.default = _default;